import { render, staticRenderFns } from "./Lista_UtilizxBeneficiario.vue?vue&type=template&id=88627062&scoped=true&"
import script from "./Lista_UtilizxBeneficiario.vue?vue&type=script&lang=js&"
export * from "./Lista_UtilizxBeneficiario.vue?vue&type=script&lang=js&"
import style0 from "./Lista_UtilizxBeneficiario.vue?vue&type=style&index=0&id=88627062&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88627062",
  null
  
)

export default component.exports